import { useState } from "react";
import { Form } from "antd";

import { type ScheduledAssignHabitsAutomation } from "@fitness-app/data-models/entities/AutomationTemplate";
import { type ProgramAutomationScheduledTask } from "@fitness-app/data-models/entities/ProgramAutomation";

import { type AssignHabitsTaskFormModel } from "./types";

// scheduleTiming lives on the ProgramAutomationScheduledTask wrapper, so keep it
// on the edited task to preload the package-anchor fields (TRE-1612).
type EditedAssignHabitsTask = ScheduledAssignHabitsAutomation & Pick<ProgramAutomationScheduledTask, "scheduleTiming">;

export const useAssignHabitsTaskForm = () => {
  const [visible, toggleVisibility] = useState(false);
  const [formController] = Form.useForm<AssignHabitsTaskFormModel>();
  const [editedTask, setTask] = useState<null | EditedAssignHabitsTask>(null);

  const closeModal = () => {
    toggleVisibility(false);
    setTask(null);
  };

  const openModal = (task?: EditedAssignHabitsTask) => {
    if (task) {
      setTask(task);
    }
    toggleVisibility(true);
  };

  return {
    visible,
    closeModal,
    openModal,
    editedTask,
    formController,
  };
};
